"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _reactResizeDetector = require("react-resize-detector");

var _PreviewFormat = _interopRequireDefault(require("./PreviewFormat"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _Grid = _interopRequireDefault(require("./Grid"));

var _Timeline = _interopRequireDefault(require("./Timeline"));

var _AnnotateImagemap = _interopRequireDefault(require("./AnnotateImagemap"));

var _AnnotateLegends = _interopRequireDefault(require("./AnnotateLegends"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const templates = {
  "device": _Menu.default,
  "page/annotate/imagemap": _AnnotateImagemap.default,
  "page/annotate/legends": _AnnotateLegends.default,
  "page/timeline": _Timeline.default,
  "page/list": _Grid.default,
  "page/grid": _Grid.default,
  "page/media": _Grid.default,
  "page/media/gallery": _Grid.default,
  "page/media/autoplay": _Grid.default,
  "page": _Grid.default
};
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: props => {
      return 'url(' + props.backgroundImageUrl + ')';
    },
    backgroundPosition: "50% 50%",
    backgroundSize: "cover",
    fontSize: props => {
      return props.fontSize;
    }
  },
  page: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    width: "100%",
    height: "100%"
  },
  header: {
    width: "100%",
    display: "flex",
    margin: theme.spacing(2)
  },
  title: {
    fontSize: "3em"
  },
  body: {
    flexBasis: "100%",
    flexGrow: 1,
    width: "100%",
    position: "relative"
  },
  footer: {
    flexBasis: "15%",
    width: "100%",
    margin: theme.spacing(2)
  }
}));

const PreviewPage = (_ref) => {
  let width = _ref.width,
      height = _ref.height,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "height"]);

  const fontSize = width / 64 + "px";
  const classes = useStyles({
    fontSize: fontSize
  });
  const formData = props.formData;
  const documentType = formData.documentType,
        content = formData.content;
  let layout;

  if (documentType === "page/annotate") {
    layout = content && content.annotateLayout;
  }

  if (documentType === "page/media") {
    layout = content && content.mediaLayout;
  }

  let template;

  if (layout) {
    template = documentType + "/" + layout;
  } else {
    template = documentType;
  }

  let PreviewTemplate = templates && templates[template];

  if (!PreviewTemplate) {
    return _react.default.createElement("p", null, "No preview for ", template);
  }

  return _react.default.createElement(_PreviewFormat.default, {
    format: "16:9"
  }, _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(PreviewTemplate, props)));
};

PreviewPage.defaultProps = {
  formData: {},
  formContext: {}
};

var _default = (0, _reactResizeDetector.withResizeDetector)(PreviewPage);

exports.default = _default;
module.exports = exports.default;